import React from "react";
import { Modal } from "react-bootstrap";
import { TriangleAlert } from "lucide-react";

// Shared popup for scan-side native bridge failures (low-quality signal,
// face-detection timeout, etc). Content is fully dynamic so every variant
// reuses one consistent look.
const ScanIssueModal = ({ show, onClose, onRetry, title, body, footer, buttonText }) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      contentClassName="low-quality-scan-modal"
    >
      <Modal.Body className="text-center p-4">
        <div className="low-quality-scan-icon">
          <TriangleAlert size={32} strokeWidth={2.25} />
        </div>
        <h4 className="low-quality-scan-title">{title}</h4>
        <p className="low-quality-scan-body">{body}</p>
        <p className="low-quality-scan-footer">{footer}</p>
        <button
          type="button"
          className="btn btn-primary w-100 low-quality-scan-btn"
          onClick={onRetry}
        >
          {buttonText}
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default ScanIssueModal;
